import { type FunctionComponent } from 'react';
import { compareStrings } from '@lib/utils';
import {
  EuiFlexGrid,
  EuiFlexItem,
  EuiSkeletonText,
  EuiSpacer,
} from '@elastic/eui';
import type { Group, Person } from '@domain/person';
import { usePersonGroups } from '@data/groups';
import GroupPanel from './group-panel';
import AddGroup from './add-group';

interface GroupSectionProps {
  person: Person;
}

const GroupSection: FunctionComponent<GroupSectionProps> = ({ person }) => {
  const { loading, groups } = usePersonGroups(person.idnumber);

  if (loading) {
    return <EuiSkeletonText lines={3} />;
  }

  const sortedGroups = [...(groups as Group[])];
  sortedGroups.sort((a, b) =>
    compareStrings(a.name.toUpperCase(), b.name.toUpperCase())
  );
  return (
    <>
      {!person.authn?.suspended && (
        <AddGroup person={{ ...person, groups: sortedGroups }} />
      )}
      <EuiSpacer size="s" />
      <EuiFlexGrid columns={3} gutterSize="s">
        {sortedGroups.map(group => (
          <EuiFlexItem key={group.name}>
            <GroupPanel person={person} group={group} />
          </EuiFlexItem>
        ))}
      </EuiFlexGrid>
    </>
  );
};

export default GroupSection;
